const Dining = () => {

    const handleSideNav = () => {
        if (document.querySelector(".main-nav").classList.contains("slidenav")) {
            document.querySelector(".main-nav").classList.remove("slidenav")
        }
    }

    return (
        <div onClick={handleSideNav}>

            <div className="breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-wrapper">
                                <div className="breadcrumb-inner">
                                    <h1>Poseidons at Riverside</h1>
                                    <span><a href="/">Home<i className="fas fa-angle-right"></i></a>Poseidons at Riverside</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="restaurant-area" style={{marginTop: "10em"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-xl-6 or2">
                            <div className="restaurant-left">
                                <h2>Poseidons at Riverside</h2>
                                <p>Nestled within the elegant Riverside Country Club, Poseidon's brings world-class cuisine to our charming small town. <b>Open to the public (no membership required)</b>, our intimate fine-dining restaurant offers an exquisite escape where fresh seafood, prime steaks, and seasonal ingredients meet impeccable service and breathtaking riverside views.</p>
                                <p>Indulge in artfully crafted dishes inspired by our award-winning chef’s French cuisine upbringing —paired with an elegant wine list and handcrafted cocktails. Whether you’re celebrating a milestone, hosting an unforgettable date night, or just looking to get out, let us serve you in a sophisticated atmosphere without the pretension!</p>

                                <p>Summer restaurant hours are Tuesday through Saturday:</p>
                                <p><b>Lunch: 11:00am-4:00pm</b></p>
                                <p><b>Dinner: 5:00pm-9:00pm</b></p>

                                <p>Winter restaurant hours are Tuesday through Saturday from 5:00PM-9:00PM</p>

                                <p>Reservations are not currently necessary, but are encouraged! Call today at 906-863-4837 or 906-290-3777 to reserve your table!</p>
                                <ul className="field-points">
                                    <li><i className="bi bi-check2-circle"></i> Indoor Seating</li>
                                    <li><i className="bi bi-check2-circle"></i> Outdoor Seating</li>
                                    <li><i className="bi bi-check2-circle"></i> Dinner Menu</li>
                                    <li><i className="bi bi-check2-circle"></i> Lunch Menu</li>
                                    {/* <li><i className="bi bi-check2-circle"></i> scelerisque sapien massa maxi.</li>
                                    <li><i className="bi bi-check2-circle"></i> varius vehicula libvel archu ru.</li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-6 or1">
                            <div className="restaurant-images">
                                <div className="img-1">
                                    <img src="assets/img/dining/P1055290.jpg" alt="" style={{maxWidth: "371px", maxHeight: "189px"}}/>
                                </div>
                                <div className="img-2">
                                    <img src="assets/img/dining/P1055303.jpg" alt="" style={{maxWidth: "325px", maxHeight: "192px"}} />
                                </div>
                                <div className="img-3">
                                    <img src="assets/img/dining/P1055314.jpg" alt="" style={{maxWidth: "255px", maxHeight: "177px"}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row" style={{justifyContent: "center", marginBottom: "5em"}}>
                <div className="col-lg-5" style={{textAlign: "center"}}>
                    <img src="assets/img/dining/P1044800.jpg" alt="patio" style={{maxHeight: "770px"}}></img>
                </div>
                <div className="col-lg-5" style={{textAlign: "center"}}>
                    <img src="assets/img/dining/P1044797.jpg" alt="indoor seating" style={{maxHeight: "770px"}}></img>
                </div>                
            </div>            

            <div className="serve-area sec-mar-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-xl-6">
                            <div className="serve-content">
                                <h2>What Do We Serve</h2>
                                <p>Check out our full menu below!</p>
                            </div>
                            <div>
                                <img src="assets/img/dining/P1055305.jpg" alt="" style={{maxWidth: "473px", maxHeight: "300px"}} />
                            </div>                            
                        </div>                        
                        <div className="col-lg-6 col-xl-6">
                            <div className="serve-images">
                                <div className="img-1">
                                    <img src="assets/img/dining/P1055321.jpg" alt="" style={{maxWidth: "371px", maxHeight: "189px"}} />
                                </div>
                                <div className="img-2">
                                    <img src="assets/img/dining/P1055329.jpg" alt="" style={{maxWidth: "373px", maxHeight: "194px"}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                            
            <div className="row" style={{justifyContent: "center", marginBottom: "10em"}}>
                <div className="col-lg-8" style={{textAlign: "center"}}>
                    <img src="assets/img/MENU_Page_1.png" alt="menu" style={{maxWidth: "90%"}}></img>
                    <img src="assets/img/MENU_Page_2.png" alt="menu1" style={{maxWidth: "90%"}}></img>
                    <img src="assets/img/MENU_Page_3.png" alt="menu2" style={{maxWidth: "90%"}}></img>
                </div>
            </div>

        </div>
    )
}

export default Dining